export const CREATE_USER_SESSION = 'create_user_session';
export const DESTROY_USER_SESSION = 'destroy_user_session';

export default {
  CREATE_USER_SESSION,
  DESTROY_USER_SESSION,
};
